import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IConfiguration } from "../../services/data-file-import-data-service/Models";
import DataFileImportDataService from "../../services/data-file-import-data-service/DataFileImportDataService";

export type UseDataFileImportConfigurationsParams = {
    groupID: number,
} & BaseUseQueryParameters<IConfiguration[] | undefined>;

export function useDataFileImportConfigurations({
    groupID,
    enabled,    
    onSuccess,
    onError
}: UseDataFileImportConfigurationsParams) {
    return useQuery<IConfiguration[], RestError>(
        keys.configurations(groupID),
        ({ signal }) => {
            return DataFileImportDataService.getDataFileImportConfigs(
                groupID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            // refetchInterval: false,
            // staleTime: Infinity,
            // refetchOnWindowFocus: false,
            // refetchOnMount: true,
            // refetchOnReconnect: false,
            // retry: false,
        }
    );
}